import script from "./app-showcase.vue?vue&type=script&setup=true&lang=js"
export * from "./app-showcase.vue?vue&type=script&setup=true&lang=js"

import "./app-showcase.vue?vue&type=style&index=0&id=1c359431&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/ciyc-web-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c359431"]])

export default __exports__